import React, { useEffect, useState } from "react";
import { getFlats, manualFlatAssignment } from "../../services/flats";
import { getUsers } from "../../services/users";
import { AutoComplete, Button, Form, Select, message } from "antd";

const ManualFlatAssignment = () => {
  const [flats, setFlats] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const fetchFlats = () => {
    getFlats().then((res) => {
      if (Array.isArray(res)) {
        setFlats([...res]);
      }
    });
  };
  const fetchUsers = () => {
    getUsers().then((res) => {
      if (Array.isArray(res)) {
        setUsers([...res]);
      }
    });
  };

  const onFlatSelect = (item: any) => {
    console.log("item", item);
    return true;
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (
    input: string,
    option?: {
      block: string;
      flat_no: string;
      floor: string;
      value: string;
      comb: string;
    }
  ) =>
    (option?.block ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.floor ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.flat_no ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.comb ?? "").toLowerCase().includes(input.toLowerCase());

  // Filter `option.label` match the user type `input`
  const filterOptionUser = (
    input: string,
    option?: {
      username: string;
      sur_code: string;
      phone: string;
      value: string;
    }
  ) =>
    (option?.username ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.sur_code ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.phone ?? "").toLowerCase().includes(input.toLowerCase());

  const onFinish = async (values: any) => {
    console.log("values", values);
    try {
      const res = await manualFlatAssignment(values);
      console.log("res", res);
      if (res?.status) {
        message.success(res?.message);
      } else {
        message.error(res?.message);
      }
    } catch (e) {
      message.error("Something went wrong");
    }
  };

  useEffect(() => {
    fetchFlats();
    fetchUsers();
  }, []);
  return (
    <Form
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      style={{ maxWidth: 600 }}
      onFinish={onFinish}
    >
      <Form.Item
        label="Select Flat"
        name="flat_id"
        rules={[{ required: true, message: "Please select flat" }]}
      >
        <Select showSearch filterOption={filterOption}>
          {flats?.map((item) => (
            <Select.Option
              value={item?.flat_id}
              block={item?.block}
              flat_no={item?.flat_no}
              floor={item?.floor}
              comb={`${item?.block}-${item?.flat_no}-${item?.floor}`}
            >
              {item?.block} - {item?.flat_no} - {item?.floor}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Select User"
        name="user_id"
        rules={[{ required: true, message: "Please select user" }]}
      >
        <Select showSearch filterOption={filterOptionUser}>
          {users?.map((item) => (
            <Select.Option
              value={item?.user_id}
              username={item?.name}
              sur_code={item?.sur_code}
              phone={item?.phone}
            >
              {item?.name}-({item?.sur_code})-({item?.phone})
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ManualFlatAssignment;
